import React, { Component } from 'react';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Function} onClose
 * @prop {Boolean} show
 * @prop {React.ReactNode} children
 *
 * @augments {Component<Props>}
 */
export default class Modal extends Component {

	componentDidMount () {
		document.body.addEventListener('keydown', this.closeOnEscapeKeyDown);
	}

	componentWillUnmount () {
		document.body.removeEventListener('keydown', this.closeOnEscapeKeyDown);
	}

	closeOnEscapeKeyDown = (e) => {
		if (e.code === 'Escape') {
			this.props.onClose();
		}
	};

	render () {
		const { show, onClose, children } = this.props;

		if (!show) return null;
		return (
			<div className='Modal'>
				<div
					className={`modal ${show ? 'visible' : ''}`}
					// @ts-ignore
					onClick={onClose}
				>
					<div
						className='modal-content'
						onClick={(e) => e.stopPropagation()}
					>
						<div className='modal-body'>
							<div
								className='close'
								// @ts-ignore
								onClick={onClose}
							/>
							{children}
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/Modal.js